<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <!-- <form @submit.prevent="setFilter"> -->
        <h6 class="heading-small text-muted mb-4">Search</h6>
        <div class="row">
          <div class="col">
            <form @submit.prevent="setFilter">
              <a-input placeholder="Search by" v-model="table.filters.name">
                <a-select
                  slot="addonAfter"
                  default-value="name"
                  style="width: 110px"
                >
                  <a-select-option value="name">
                    name
                  </a-select-option>
                </a-select>
              </a-input>
              <hr />
          <h6 class="heading-small text-muted mb-4">
            Filter by Registration Status
          </h6>
          <div class="row">
            <div class="col">
              <a-radio-group
                v-model="table.filters.status"
                :default-value="null"
                @change="setFilter"
              >
                <a-radio :style="radio.style" :value="null">
                  All
                </a-radio>
                <a-radio :style="radio.style" value="A">
                  Active
                </a-radio>
                <a-radio :style="radio.style" value="I">
                  Inactive
                </a-radio>
              </a-radio-group>
            </div>
          </div>
            </form>
          </div>
        </div>
        <!-- </form> -->
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          :sortOrder="table.sortOrder"
        >
          <template #headerButtons>
              <base-button
                id="new"
                class="float-right ml-1"
                type="primary"
                size="sm"
                v-if="selectedActions.includes('Add')"
                @click="openDrawer()"
                >+ Create Voucher</base-button
              >
            <base-button
              id="claim"
              class="float-right ml-1"
              type="success"
              size="sm"
              @click="openClaimDrawer()"
              >Claim Voucher</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <VoucherForm
                :viewMode="viewMode"
                :voucherData="voucherData"
                :systemModules="systemModules"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="claimDrawer.visible"
              @close="closeDrawer"
            >
              <ClaimVoucherForm
                :systemModules="systemModules"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{tableProps}">
            <button
              id="view"
              v-if="selectedActions.includes('View')"
              class="btn btn-success btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>

            <button
              id="edit"
              v-if="selectedActions.includes('Edit')"
              class="btn btn-warning btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Edit
            </button>
            <!-- <a-popconfirm
              title="You are about to delete this record?"
              @confirm="deleteRow(tableProps.rowData)"
              okText="Delete"
              cancelText="Cancel"
            >
              <a class="btn btn-danger btn-sm text-white">Delete</a>
            </a-popconfirm> -->
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import VoucherForm from './VoucherForm.vue';
import ClaimVoucherForm from './ClaimVoucherForm.vue';
import HTTPRequest from '@/controllers/httpRequest';
import { mapGetters } from 'vuex';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    VoucherForm,
    ClaimVoucherForm,
  },
  data() {
    return {
      gradientType: 'gradient-blue',
      voucherData: null,
      systemModules: null,
      drawer: {
        visible: false,
        width: 800,
        placement: 'right'
      },
      claimDrawer: {
        visible: false,
        width: 800,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Voucher',
        apiUrl: '/api/v1/vouchers',
        fields: [
          'actions',
          { name: 'id', title: 'Id' },
          { name: 'code', title: 'Code' },
          { name: 'name', title: 'Name' },
          { name: 'voucherType.name', title: 'Type' },
          { name: 'available', title: 'Available', formatter(value) { return value.length } },
          { name: 'claimed', title: 'Claimed', formatter(value) { return value.length } },
          { name: 'used', title: 'Used', formatter(value) { return value.length } },
          { name: 'status', title: 'Status' },
        ],
        sortOrder: [
          {
            field: 'id',
            direction: 'asc'
          }
        ],
        filters: {
          status: null
        }
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  methods: {
    async openClaimDrawer() {
      this.claimDrawer.visible = true;
    },
    async openDrawer(rowData = null) {
      this.voucherData = rowData;

      this.viewMode = event.target.id == 'view' ? true : false;
      this.drawer.visible = true;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.claimDrawer.visible = false;
      this.voucherData = null;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    },
    async deleteRow(rowData) {
      const voucherId = rowData.id;
      const response = await HTTPRequest.deleteRequest(
        `/api/v1/vouchers/${voucherId}`
      );

      if (response.message == 'Success') {
        this.$notification.success({
          message: 'Success'
        });
        this.$root.$emit('refreshTable');
      } else {
        if (response.error != undefined) {
          this.$notification.error({
            message: response.error
          });
        } else {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },

  created() {
    this.$store.dispatch('setCurrentModule', 'Voucher');
  }
};
</script>

<style scoped></style>
